import * as React from 'react'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { useCallback } from 'react'
import { Divider, Title } from './atoms'
import { useFormikContext } from 'formik'
import { LeadAssignmentRuleFormModel } from './typings'
import { getTouchedObject } from '@sales-center/common'
import { useTheme } from '@mui/material/styles'

type Props = {
  isEditPage: boolean
}

export function PageHeader(props: Props) {
  const { isEditPage } = props
  const { submitForm, isSubmitting, setTouched, errors } =
    useFormikContext<LeadAssignmentRuleFormModel>()
  const saveForm = useCallback(
    (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      event.preventDefault()
      event.stopPropagation()
      submitForm()
      setTouched(getTouchedObject(errors))
    },
    [submitForm, errors, setTouched],
  )

  const title = `${isEditPage ? 'Edit' : 'Create New'} Assignment Rule`
  const theme = useTheme()
  return (
    <Stack
      flexDirection="row"
      sx={{ backgroundColor: theme.palette.common.white }}
    >
      <Title>{title}</Title>
      <Divider />
      <Box paddingRight="17px" paddingTop="20px" paddingBottom="21px">
        <Button
          disabled={isSubmitting}
          onClick={saveForm}
          variant="contained"
          data-test-id="assignmentRule_saveBtn"
        >
          Save
        </Button>
      </Box>
    </Stack>
  )
}
